<template lang="pug">
  b-container
    tutorial-modal(view="Recursos")
      template(v-slot:default)
        b-container
          p Administra los recursos disponibles para la vista de Casos:
          ul
            li Grupos de Casos
            li Etiquetas
            li Respuestas
            li Agentes
          h5 Grupos de Casos
          h5 Etiquetas
          p Para agregar etiquetas a los casos debes crearlas aquí. Se separan por categorías, pero si no deseas usar categorías solo crea la categoría General y crea todas en ésta.
          h5 Respuestas
          p.mb-2 Te permite crear plantillas de respuestas para contestar más rápido en las conversaciones textos que usualmente respondes. Puedes agregar imágenes y documentos en la respuesta.
          p Éstas están disponibles en el botón [+] junto al cuadro de texto para responder Casos.
          h5 Agentes
          p.mb-2 Si tienes un equipo de personas que te ayudan a contestar Casos y Chats, puedes darles el rol de permisos limitados llamado Agente. Este rol solo tiene acceso a Casos y Chats en tu cuenta y no puede ver ninguna otra vista.
          p Los agentes y admins con acceso a tu cuenta puede asignarse a Casos y Chats para que los atiendan solo ellos en el momento.
          b-alert(variant="info", show) Si un admin/agente cambia su estado a Disponible, se le asignarán casos automáticamente o puede ir seleccionando casos manualmente en estado Desconectado.
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Administrar recursos
    b-row.mt-4
      b-col(cols="12")
        b-nav.mb-4(tabs)
          b-nav-item(:to="{name: 'Groups'}") Grupos
          b-nav-item(:to="{name: 'Tags'}") Etiquetas
          b-nav-item(:to="{name: 'Responses'}") Respuestas
          b-nav-item(:to="{name: 'Agents'}", v-if="$can('read', 'admin-view')") Agentes
        router-view
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import TutorialModal from '@/components/TutorialModal.vue'

export default {
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  },
  components: { TutorialModal }
}
</script>

<style lang="scss" scoped>
</style>
